import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import Text from '../Text';
import SectionHeader from '../SectionHeader';
import ScrollReveal from '../animated/ScrollReveal';
import { colors, gradients } from '../../theme/designTokens';
import { ecosystemNodes } from '../../data/insights';

const EcosystemSection = () => (
  <Box
    sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: { xs: 8, md: 12 },
      background: gradients.sectionDark,
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <Box sx={{ maxWidth: 1100, mx: 'auto', position: 'relative', zIndex: 1 }}>
      <ScrollReveal>
        <SectionHeader
          eyebrow="What We Do"
          title="A resilience ecosystem."
          highlightWords={['ecosystem']}
          subtitle="Insurance is one layer inside an integrated system of prevention, intelligence, technology, response, and recovery."
          light
        />
      </ScrollReveal>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' },
          gap: { xs: 2, md: 2.5 },
          mt: 2,
        }}
      >
        {ecosystemNodes.map((node, i) => {
          const isInsurance = node === 'Insurance';
          return (
            <Box
              key={node}
              component={motion.div}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06, duration: 0.5 }}
              whileHover={{ y: -4 }}
              sx={{
                py: { xs: 3, md: 4 },
                px: 2,
                textAlign: 'center',
                border: `1px solid ${isInsurance ? colors.silver : colors.glassBorder}`,
                background: isInsurance ? 'rgba(192,199,209,0.08)' : 'rgba(255,255,255,0.03)',
              }}
            >
              <Text
                variant="eyebrow"
                sx={{ color: isInsurance ? colors.ochre : 'rgba(255,255,255,0.45)', mb: 1.5, display: 'block' }}
              >
                {String(i + 1).padStart(2, '0')}
              </Text>
              <Text variant="h4" color="white">
                {node}
              </Text>
              {isInsurance && (
                <Text
                  variant="caption"
                  sx={{ color: colors.ochre, mt: 1, display: 'block' }}
                >
                  One strategic layer
                </Text>
              )}
            </Box>
          );
        })}
      </Box>

      <ScrollReveal delay={0.2}>
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Text variant="h3" color="white" sx={{ mb: 1 }}>
            RESILIENCE
          </Text>
          <Text variant="body" color="muted">
            The outcome of an integrated protection architecture—not a product line.
          </Text>
        </Box>
      </ScrollReveal>
    </Box>
  </Box>
);

export default EcosystemSection;
